import {useAccessToken} from "../../services/auth"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {getOrg, getOrgName} from "../../resources/org"
import React from "react"
import Skeleton from "react-loading-skeleton"
import {Resource} from "../../resources/common"

// type ElementProps<P> = Pick<Props<P> & P, Exclude<keyof P, "element" | "orgId">>
// TODO: revert changes when we upgrade to newer typescript
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Props<P> {
	orgId: string
	included?: Resource[]
	token?: string
	element?: React.ElementType
	width?: number
}

function AsyncOrgName<P>({orgId, element, ...props}: Props<P> & P) {
	const accessToken = props.token ?? useAccessToken()
	const result = useAsyncResult(() => getOrg(accessToken, orgId), [orgId])
	const Elem = element as React.ElementType

	return result.match(
		() => (
			<Elem {...props}>
				<Skeleton {...(props.width ? {width: props.width} : {})} />
			</Elem>
		),
		(org) => <Elem {...props}>{getOrgName(org)}</Elem>,
		(_) => <Elem {...props}>Error</Elem>
	)
}

function SyncOrgName<P>({orgId, element, ...props}: Props<P> & P) {
	const org = props?.included?.find((r) => r.type === "org" && r.id === orgId)
	const Elem = element as React.ElementType
	if (org && org.type == "org") {
		return <Elem {...props}>{getOrgName(org)}</Elem>
	}

	return <Elem {...props}>Error</Elem>
}

export function OrgName<P extends {}>({element = "td", ...props}: Props<P> & P) {
	if (props.included) {
		return <SyncOrgName element={element} {...props} />
	}

	return <AsyncOrgName element={element} {...props} />
}
